import { Helmet } from '@dr.pogodin/react-helmet';
import jwtDecode from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-typed-form';

import { API_ROOT } from '../../config';
import { FormWrap } from '../../form';
import AuthBoxWrap from './AuthBoxWrap';
import AuthHeading from './AuthHeading';
import AuthSubmitButton from './AuthSubmitButton';
import LoginField from './LoginField';

export default function LoginPage() {
  const dispatch = useDispatch();
  const { formErrorList, getField, handleSubmit, isLoading } = useForm<{
    username: string;
    password: string;
  }>({
    defaultValues: { username: '', password: '' },
    onSubmit: async (values, { addSubmitError, setLoading }): Promise<void> => {
      setLoading(true);
      const response = await fetch(`${API_ROOT}/login_check`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...values,
          username: values.username.toLowerCase().trim(),
        }),
      });
      setLoading(false);

      if (response.status === 401) {
        addSubmitError('_form', 'Invalid username or password');
        return;
      }
      const data = await response.json();

      const decoded = jwtDecode<{
        id: string;
        username: string;
        roles: string[];
      }>(data.token);

      dispatch({
        type: 'LOGIN',
        payload: {
          id: decoded.id,
          email: decoded.username,
          roles: decoded.roles,
          jwt: data.token,
        },
      });
    },
  });

  return (
    <AuthBoxWrap>
      <Helmet>
        <title>Sign in</title>
      </Helmet>
      <AuthHeading>Sign in to your management console</AuthHeading>
      <FormWrap formErrorList={formErrorList} handleSubmit={handleSubmit}>
        <LoginField
          field={{ ...getField('username'), label: 'Email' }}
          autoFocus
        />
        <LoginField type="password" field={getField('password')} />

        <AuthSubmitButton disabled={isLoading}>Sign in</AuthSubmitButton>
      </FormWrap>
    </AuthBoxWrap>
  );
}
